import { BorderColors, BorderRadius } from "@abel-technologies-as/components";
import styled from "styled-components";

const ModalIconWrapper = styled.div`
	width: 48px;
	height: 48px;
	padding: 10px;
	border-radius: ${BorderRadius.LG}px;
	box-shadow: 0px 1px 2px 0px #1018280d;
	display: flex;
	justify-content: center;
	align-items: center;
	border: 1px solid ${BorderColors.Secondary};
`;

export { ModalIconWrapper };
